import controller from './payment-progress.controller';

export default {
  controller,
  template: require('./payment-progress.html')
};



// WEBPACK FOOTER //
// src/app/components/payment-progress/payment-progress.component.ts